<button class="grid-note" (click)="downloadInvoice()">
    <mat-icon color="primary">description</mat-icon>
</button>
